import { Component, OnInit } from '@angular/core';
import { LibraryService,MentorService} from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-stuallot',
  templateUrl: './stuallot.component.html',
  styleUrls: ['./stuallot.component.scss'],
  providers:[LibraryService,MentorService]
})
export class StuallotComponent implements OnInit {
  staffs=[];
  classes=[];
  stualloted=[];
  stuavailable=[];
  selstaff:any;
  selclass:any;
  closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  constructor(private http: HttpClient, private liservice: LibraryService,private mentservice: MentorService,private modalService: NgbModal) { }

  ngOnInit(): void {

    this.getstaffdetails('selemp','');
    this.classdetails();
    this.getstudentdata('sel_alloted')
  }

  getstaffdetails(oprtype,sertxt) {
    this.liservice.getmemberdetails(oprtype,sertxt,0,0)
        .subscribe(
        resultArray => {
            console.log('members-result', resultArray);
           
            this.selstaff=resultArray[0].stuid;
            let resSTR = JSON.stringify(resultArray);
      
          this.composefilterstaff(resSTR);
            
        },
        error => console.log("Error :: " + error)
        )
  }

  classdetails() {
    this.mentservice.classmaster()
        .subscribe(
        resultArray => {
            console.log('members-result', resultArray);
           //resultArray.splice(0,1);
            this.selclass=resultArray[0].clid;
            let resSTR = JSON.stringify(resultArray);
          
            this.composefilterclass(resSTR);
            
        },
        error => console.log("Error :: " + error)
        )
  }
  getstudentdata(oprtype) {
    this.mentservice.getstualloted(this.selclass,this.selstaff,oprtype)
        .subscribe(
        resultArray => {
            console.log('members-result', resultArray);
           //resultArray.splice(0,1);
           if (oprtype=='sel_alloted')
           {
            this.stualloted=resultArray;
           }
            else if(oprtype=='sel_nonalloted')
            {
              this.stuavailable=resultArray;

            }
            
        },
        error => console.log("Error :: " + error)
        )
  }


  allotstudent(id,stuid,oprtype) {
    this.mentservice.allotstudent(stuid,this.selstaff,oprtype,id)
        .subscribe(
        resultArray => {
            console.log('members-result', resultArray);
            alert(resultArray.message)
           //resultArray.splice(0,1);
           this.getstudentdata('sel_nonalloted');
           this.getstudentdata('sel_alloted');
            
        },
        error => console.log("Error :: " + error)
        )
  }

  openinfo(content)
{
  this.getstudentdata('sel_nonalloted');
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop'
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        
    });
}

  composefilterclass(jstring)
{
  var newstr = jstring.replace(/clid/g, "value"); 
  var newstr = newstr.replace(/clname/g, "label"); 
  console.log('jsonrep',newstr);
  let resJSON = JSON.parse(newstr);
  var arr=Array.of(resJSON);
  
  this.classes=arr[0];
  console.log('classes',this.classes);
}

composefilterstaff(jstring)
{
  var newstr = jstring.replace(/emid/g, "value"); 
  var newstr = newstr.replace(/emnm/g, "label"); 
  console.log('jsonrep',newstr);
  let resJSON = JSON.parse(newstr);
  var arr=Array.of(resJSON);
  
  this.staffs=arr[0];
  console.log('staffs',this.staffs);
}
onChangeclass(val)
{

  this.selclass=val;
  this.getstudentdata('sel_alloted');
}

onChangestaff(val)
{

  this.selstaff=val;
  this.getstudentdata('sel_alloted');
}
}
